// removed by extract-text-webpack-plugin
module.exports = {"RichText":"_2HXTTpyMMYVBe73aH2HV7m","headers":"_1hhj5QnLBUrRzjvaHATAxr","subHeader":"fnksh8bCQTkoAAZ7ER42r","framerWrapper":"_3YbFlHtTLQxXwQwFAdvoGV","content":"_2fMstMN3olTcvULTEx8vQe","contentWithFrame":"_1yMg3dpVvGHUR-PMnv9gge _2fMstMN3olTcvULTEx8vQe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichText/RichText.css
// module id = 201
// module chunks = 8